export default "__VITE_ASSET__B4bZLi0N__"